import axios from '@/plugins/axios'
import { Module } from 'vuex'

export interface Signup {
    userdescription: string
    token: string
}

const signupModule: Module<any, any> = {
    actions: {
        async register(_, params) {
            const {data} = await axios.post('/api/signup/init', params)
            return data
        },
        async updateRegistration(_, params) {
            const {data} = await axios.post('/api/signup/update', params)
            return data
        },
    },
}

export default signupModule
